import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { DiscountsAppliedDto } from '../../models/tuitionCalculation/discountsAppliedDto';
import { AppliedLearningResourceDto } from '../../models/tuitionCalculation/appliedLearningResourceDto';
import { AppliedAcademicFeeDto } from '../../models/tuitionCalculation/appliedAcademicFeeDto';
import { ShippingRatesAppliedDto } from '../../models/tuitionCalculation/shippingRatesAppliedDto';
import { OptionalAdministrativeFeeAppliedDto } from '../../models/tuitionCalculation/optionalAdministrativeFeeAppliedDto';
import { MandatoryAdministrativeFeeAppliedDto } from '../../models/tuitionCalculation/mandatoryAdministrativeFeeAppliedDto';
import { TranslatePipe } from '@ngx-translate/core';
import { DescriptionTraductionDto } from '../../models/launcher/descriptionTraductionDto';
import { DiscountModalComponent } from '../discount-modal/discount-modal.component';
import { TaxAndDiscountDetailsDto } from '../../models/tuitionCalculation/taxAndDiscountDetailsDto';

@Component({
  selector: 'app-generic-rate-list',
  standalone: true,
  imports: [DiscountModalComponent, TranslatePipe],
  templateUrl: './generic-rate-list.component.html',
  styleUrl: './generic-rate-list.component.css'
})
export class GenericRateListComponent {

  @Input() idTaxGeneric!: number;

  @Input() listTraductionGeneric!: DescriptionTraductionDto[];

  @Input() listAppliedAcademicFee!: AppliedAcademicFeeDto;

  @Input() listAppliedLearningResourceRate!: AppliedLearningResourceDto;

  @Input() listShippingRatesApplied!: ShippingRatesAppliedDto;

  @Input() listOptionalAdministrativeFeeApplied!: OptionalAdministrativeFeeAppliedDto;

  @Input() listMandatoryAdministrativeFeeApplied!: MandatoryAdministrativeFeeAppliedDto;

  @Input() titleTax!: string;

  @Output() openDiscount = new EventEmitter<DiscountsAppliedDto>();

  @Input() administrativeModificationFeeIndicator!: string;

  @Input() administrativeCancelationFeeIndicator!: string;

  discountViewModal!: DiscountsAppliedDto;

  isViewDiscount: boolean = false;

  taxAndDiscount!: TaxAndDiscountDetailsDto;

  idModal!: string;

  discounts: DiscountsAppliedDto[] = [];

  constructor(private sharedService: SharedService,
    private cd: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    this.genericTaxAndDiscountDetails();
    this.sharedService.initSelectDiscountModal.subscribe((isView) => {
      this.isViewDiscount = isView;
    });
  }

  /**
   * Funcíon ecargada de activar o desactivar los descuentos obteniendo una nueva referencia
   * @param _ 
   */
  ngOnChanges(_: SimpleChanges): void {
    // 1) elegir la fuente actual (el hijo se usa para varios tipos)
    const src =
      this.listAppliedAcademicFee ??
      this.listAppliedLearningResourceRate ??
      this.listMandatoryAdministrativeFeeApplied ??
      this.listOptionalAdministrativeFeeApplied;

    this.taxAndDiscount = src?.taxAndDiscountDetails;

    // 2) forzar NUEVA referencia para que OnPush detecte el cambio
    this.discounts = [...(this.taxAndDiscount?.listDiscountsApplied ?? [])];

    this.cd.markForCheck();
  }

  genericTaxAndDiscountDetails(): void {
    if (this.listAppliedAcademicFee) {
      this.taxAndDiscount = this.listAppliedAcademicFee.taxAndDiscountDetails;
    } else if (this.listAppliedLearningResourceRate) {
      this.taxAndDiscount = this.listAppliedLearningResourceRate.taxAndDiscountDetails;
    } else if (this.listShippingRatesApplied) {
      this.taxAndDiscount = this.listShippingRatesApplied.taxAndDiscountDetails
    } else if (this.listOptionalAdministrativeFeeApplied) {
      this.taxAndDiscount = this.listOptionalAdministrativeFeeApplied.taxAndDiscountDetails
    } else {
      this.taxAndDiscount = this.listMandatoryAdministrativeFeeApplied.taxAndDiscountDetails
    }
  }


  /**
   * Se encarga de visualizar el modal para los descuentos
   * @param listDiscount 
   */
  viewDiscount(listDiscount: DiscountsAppliedDto): void {
    this.discountViewModal = listDiscount;
    this.isViewDiscount = true;
  }


}
